export default __webpack_public_path__ + "static/media/2.ad186b20.jpg";